<div>
  <app-header></app-header>
  <div class="container">
    <div class="row d-flex justify-content-center">
      <div class="card">
        <div *ngIf="loadingPage" class="row d-flex justify-content-center mt-15">
          <div class="spinner-border" role="status"></div>
        </div>
        <div *ngIf="!loadingPage" class="card-body">
          <div *ngIf="pagoExitoso" class="card-title d-flex justify-content-center">
            <h1 class="titulo-principal">El pago ha sido exitoso </h1> <img  class="icn-ok" src="assets/icons/icon-emoji-mano.png">
          </div>
          <div *ngIf="!pagoExitoso" class="card-title d-flex justify-content-center">
            <h1 class="titulo-principal">Al parecer ocurrió un problema </h1>
          </div>
          <div *ngIf="pagoExitoso">
            <div class="row d-flex justify-content-center">
              <label  class="text-center widthText">
                Avisa a tu ejecutivo el término del pago
              </label>
            </div>
            <div class="row d-flex justify-content-center">
              <button type="button" class="btn-secondary-tbk" (click)="redirectToMarket()">Explorar más productos de Transbank</button>
            </div>
          </div>
          <div *ngIf="!pagoExitoso">
            <div class="row d-flex justify-content-center">
              <label class="subTitle">Detectamos un error en la autorización del pago.</label>
            </div>
            <div class="row d-flex justify-content-center">
              <label  class="text-center widthText">
                Por favor, avisa a tu ejecutivo que genere una nueva orden de pago.
              </label>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="footer">
    <app-footer> </app-footer>
  </div>
</div>
